import { useEffect, useRef } from "react";

const useAutoScroll = (interval = 10000) => {
  const containerRef = useRef(null);
  const indexRef = useRef(0);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const isMobile = () => window.innerWidth <= 768;
    if (!isMobile()) return;

    // Only auto-scroll if content overflows
    const canScroll = () => container.scrollWidth > container.clientWidth;
    if (!canScroll()) return;

    const scrollNext = () => {
      if (!container) return;
      const children = container.children;
      if (!children.length) return;

      const gap = parseInt(getComputedStyle(container).gap, 10) || 0;
      const cardWidth = children[0].offsetWidth + gap;
      const maxScroll = container.scrollWidth - container.clientWidth;

      indexRef.current += 1;
      let nextScroll = indexRef.current * cardWidth;

      // Loop back to start if we've reached the end — reset instantly
      // so next tick scrolls 0 → 1 smoothly (never scrolls backwards)
      if (nextScroll >= maxScroll + cardWidth / 2) {
        container.scrollTo({ left: 0, behavior: "auto" });
        indexRef.current = 0;
        return;
      }

      container.scrollTo({ left: nextScroll, behavior: "smooth" });
    };

    const id = setInterval(scrollNext, interval);
    return () => clearInterval(id);
  }, [interval]);

  return containerRef;
};

export default useAutoScroll;
